import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import MainPage from './components/MainPage/MainPage';
import LoginPage from './components/LoginPage/LoginPage';
import SelectCharacterPage from './components/SelectionPage/SelectCharacterPage';
import ChatPage from './components/ChatPage/ChatPage';
import RegisterPage from './components/RegisterPage/RegisterPage';
import LandingPage from './components/LandingPage/LandingPage';
import { getAuth, signInAnonymously } from 'firebase/auth';

function App() {
  // Ensure a user is always available by using anonymous auth if needed
  useEffect(() => {
    const auth = getAuth();
    const ensureAuthentication = async () => {
      if (!auth.currentUser) {
        try {
          // Sign in anonymously if no user is authenticated
          await signInAnonymously(auth);
          console.log('Signed in anonymously');
        } catch (error) {
          console.error('Error signing in anonymously:', error);
        }
      }
    };
    
    ensureAuthentication();
  }, []);

  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<MainPage />} />
          <Route path="/signup" element={<RegisterPage />} />
          <Route path="/login" element={<LoginPage />} />
          
          {/* Redirect /select-character to INTP chat */}
          <Route path="/select-character" element={<Navigate to="/chat/INTP" replace />} />
          
          {/* Keep the chat/:character route for dynamic character changes */}
          <Route path="/chat/:character" element={<ChatPage />} />
          
          {/* Add a default /chat route that goes directly to INTP */}
          <Route path="/chat" element={<Navigate to="/chat/INTP" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;